import { XCircle, Eye } from "lucide-react";

const DocViewModal = ({
  t,
  styles,
  theme,
  selectedDocument,
  setShowDocumentModal,
  handlePreview,
  formatDate,
  screenSize,
}) => {
  const labelStyle = {
    display: "block",
    fontSize: "13px",
    fontWeight: "700",
    color: theme === "dark" ? "rgba(255, 255, 255, 0.65)" : "rgba(30, 41, 59, 0.65)",
    marginBottom: "8px",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  };

  const valueStyle = {
    fontSize: "18px",
    fontWeight: "700",
    color: theme === "dark" ? "#fff" : "#1e293b",
  };

  return (
    <div style={styles.modalOverlay} onClick={() => setShowDocumentModal(false)}>
      <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>

        {/* Header */}
        <div style={styles.modalHeader}>
          <h3 style={styles.modalTitle}>{selectedDocument.name}</h3>
          <button
            style={styles.closeButton}
            onClick={() => setShowDocumentModal(false)}
            onMouseEnter={(e) => {
              e.currentTarget.style.background =
                theme === "dark" ? "rgba(255, 255, 255, 0.12)" : "rgba(0, 0, 0, 0.06)";
            }}
            onMouseLeave={(e) => { e.currentTarget.style.background = "none"; }}
          >
            <XCircle size={28} />
          </button>
        </div>

        {/* Details Grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: screenSize.isMobile ? "1fr" : "repeat(2, 1fr)",
            gap: "24px",
            marginBottom: "28px",
          }}
        >
          <div>
            <label style={labelStyle}>{t.fileSize}</label>
            <span style={valueStyle}>{selectedDocument.size}</span>
          </div>
          <div>
            <label style={labelStyle}>{t.format}</label>
            <span style={valueStyle}>{selectedDocument.format}</span>
          </div>
          <div>
            <label style={labelStyle}>{t.uploadDate}</label>
            <span style={valueStyle}>{formatDate(selectedDocument.uploadDate)}</span>
          </div>
          <div>
            <label style={labelStyle}>{t.status}</label>
            <span style={styles.statusBadge(selectedDocument.status)}>{selectedDocument.status}</span>
          </div>
        </div>

        {/* Tags */}
        {selectedDocument.tags && selectedDocument.tags.length > 0 && (
          <div style={{ marginBottom: "28px" }}>
            <label style={{ ...labelStyle, marginBottom: "14px" }}>{t.tags}</label>
            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
              {selectedDocument.tags.map((tag, index) => (
                <span
                  key={index}
                  style={{
                    padding: "8px 16px",
                    background: theme === "dark" ? "rgba(59, 130, 246, 0.2)" : "rgba(59, 130, 246, 0.12)",
                    border: `2px solid ${theme === "dark" ? "rgba(59, 130, 246, 0.4)" : "rgba(59, 130, 246, 0.25)"}`,
                    borderRadius: "10px",
                    fontSize: "14px",
                    fontWeight: "700",
                    color: "#3b82f6",
                    boxShadow: "0 4px 12px rgba(59, 130, 246, 0.15)",
                  }}
                >
                  #{tag}
                </span>
              ))}
            </div>
          </div>
        )}

        {/* Actions */}
        <div style={styles.modalActions}>
          <button style={styles.secondaryButton} onClick={() => setShowDocumentModal(false)}>
            {t.close}
          </button>
          <button style={styles.primaryButton} onClick={() => handlePreview(selectedDocument.id)}>
            <Eye size={20} />
            {t.viewDocument}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DocViewModal;